export default {
    title: 'MoonGroup assistant',
    welcome: {
        greeting: "Hi! I can answer questions about MoonGroup — services, products, how we work.",
        hint: 'Try one of these or ask anything:',
    },
    examplePrompts: [
        'What services do you offer?',
        'Tell me about your products',
        'How long does a typical project take?',
        'How can I get in touch?',
    ],
    composer: {
        placeholder: 'Ask anything…',
        send: 'Send',
        hint: 'Press Enter to send, Shift+Enter for a newline',
        charCount: '{used}/{max}',
    },
    states: {
        thinking: 'Thinking…',
        offline: "I'm offline for a moment — please try again in a bit.",
        rateLimited: 'A bit fast — give me a moment and try again.',
        error: 'Something went wrong. Try again?',
        paused: 'Chat is paused for a bit — please try again later.',
        inputRejected: 'That message could not be sent. Please rephrase and try again.',
        scrollToBottom: 'New message',
    },
    toast: {
        replyReady: 'The assistant replied',
        leadSent: 'Sent to the team — they\'ll be in touch',
    },
    actions: {
        expand: 'Expand',
        collapse: 'Collapse',
        close: 'Close',
        retry: 'Try again',
        openChat: 'Open chat',
        askAi: 'Ask AI',
    },
};
